import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../services/auth-service.service';
import { INewUser, IUserProfile } from '../../interfaces/';
import { NewUser, UserProfile } from '../../models/';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

	message: string = "";

  Loading: boolean= false;

  userNamePWReset: string = "";
  successful: boolean = false;
  failed: boolean = false;

  constructor( private authService: AuthServiceService, private router: Router) { }

  ngOnInit() {
    
  }  

  RequestPasswordReset(){
    this.authService.PasswordResetRequest(this.userNamePWReset).subscribe(
      resp => {
        let result = resp;
        if(resp == "Reset request received."){
          this.successful = true;
        }
        else 
          this.failed = true;
      }, error => {this.failed = true;})
  }

}




// WEBPACK FOOTER //
// ./src/app/account/forgot-password/forgot-password.component.ts